import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "28",
      fill: "none",
      stroke: "#000",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("text", {
      x: "32",
      y: "42",
      "font-family": "Arial, sans-serif",
      "font-size": "32",
      "font-weight": "bold",
      "text-anchor": "middle"
    }, "?", -1)
  ]))]))
}
export default { render: render }